import React, {memo, useEffect, useRef, useState} from "react";
import {Box, ButtonGroup, Paper} from "@mui/material";
import {toast} from "react-toastify";
import Button from "@mui/material/Button";
import Api from "../../utils/api";
import Grid from "@mui/material/Grid";
import {useParams} from "react-router-dom";
import SelectProduct from "../selectProducts/selectProduct";
import {productAction} from "../../actions";
import {connect, useSelector} from "react-redux";
import SunEditor, {buttonList} from "suneditor-react";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TextField from "@mui/material/TextField";
import "./style.css"
import Modal from "@mui/material/Modal";
import EditIcon from "@mui/icons-material/Edit";

const LandingPageCreate = memo((props) => {
    const productReducer = useSelector((state) => state.productReducer)
    const param = useParams()
    const editor = useRef();

    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };


    const initStat = {
        status: 1,
        title: '',
        link: '',
        products: [],
        form: "item_product_store",
        type: null,
        type_id: null,
        order: null,
    }

    const [form, setForm] = useState(initStat);
    const [products, setProducts] = useState({});
    const [loading, setLoading] = useState(false);
    const [editorData, setEditorData] = useState({});
    const [section, setSection] = useState(0);
    const [edit, setEdit] = useState(null);
    // const [items, setItems] = useState([]);
    const [title, setTitle] = useState("");
    // const [time, setTime] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [alarmModal, setAlarmModal] = useState(false);
    const [tempItem, setTempItem] = useState([]);
    const [address, setAddress] = useState("");
    const [copy, setCopy] = useState(false);


    useEffect(() => {
        let arr = []
        if (props.landingPageData) {
            for (let i in props.landingPageData) {
                arr.push(props.landingPageData[i])
            }
            setTempItem(arr)
        }

    }, [props.landingPageData])


    function generateSlug(titleStr){
        titleStr = titleStr.replace(/^\s+|\s+$/g, '');
        titleStr = titleStr.toLowerCase();
        //persian support
        titleStr = titleStr.replace(/[^a-z0-9_\s-ءاأإآؤئبتثجحخدذرزسشصضطظعغفقكلمنهويةى]#u/, '')
            // Collapse whitespace and replace by -
            .replace(/\s+/g, '-')
            // Collapse dashes
            .replace(/-+/g, '-');
        return titleStr;
    }

    useEffect(() => {
        setAddress(`https://digiattar.com/landing/${param?.id}/${param?.slug ? generateSlug(param?.slug) : param?.slug}`)
    }, [param])


    const handleDelete = (id , index) => {
        let arr = []

        setLoading(true);
        if(id) {
            new Api().delete('/blog/' + param.id + '/seo/item/' + id + "/destroy", {}, false).then((response) => {
                if (typeof response !== "undefined" && response.status) {
                    toast.success(response.msg)

                    for(let i = 0 ; i < response.details.items.length  ; i++) {
                        if(response.details.items?.[i]?.itemable && !response.details.items?.[i]?.itemable?.products) {
                            arr.push({content:response.details.items?.[i]?.itemable?.content , id:response.details.items?.[i]?.id , item_id:response.details.items?.[i]?.id ,type: "text",title:response.details.items?.[i]?.itemable?.title})
                        } else if(response.details.items?.[i]?.itemable && response.details.items?.[i]?.itemable?.products) {
                            arr.push({products:response.details.items?.[i]?.itemable?.products , id:response.details.items?.[i]?.id ,type: "product",title:response.details.items?.[i]?.itemable?.title})
                        }
                    }
                    setTempItem(arr)
                } else {
                    toast.error(response.msg)
                }

                setLoading(false);
            })
        } else {
            let n_tempItem = tempItem;
            n_tempItem.splice(index, 1)
            setTempItem([...n_tempItem ]);

            setLoading(false);

        }

    }


    const handleProduct = (e, id , edit , title) => {
         let arr = []

        for (const i in e.products) {
            arr.push({id:e.products[i].id , title:e.products[i].title})
        }

        let item = tempItem?.findIndex((item) => {
            return (
                item.id === id
            )
        })

        let obj = {
            "title": form.title,
            "type": "product",
            "products": arr,
        }
        products.products = obj.products

        if (id) {
            obj.id = id
            props.onChange([{...editorData, ...products, ...obj}])
        }
        setProducts({...obj})
        if(edit)
          tempItem[item].products = obj.products
    }

    const handleTitle = (e,id) => {
        form.title = e
        setTitle(e)
        let obj = {
            "type": "product",
            "title": e,
        }
        let item = tempItem?.findIndex((item) => {
            return (
                item.id === id
            )
        })
            obj.id = id
            obj.products = tempItem[item].products
            props.onChange([{...editorData, ...products, ...obj}])
    }

    const handleTitleEditor = (e,id) => {
        form.title = e
        setTitle(e)
        let obj = {
            "type": "text",
            "title": e,
        }
        let item = tempItem?.findIndex((item) => {
            return (
                item.id === id
            )
        })
            obj.id = id
            obj.content = tempItem?.[item]?.content
            props.onChange([{...editorData, ...products, ...obj}])
    }

    const handleEditor = (e, id , edit,title) => {
        let obj = {
            "type": "text",
            "content": e,
            "title": title,
        }
        let item = tempItem?.findIndex((item) => {
            return (
                item.id === id
            )
        })
        if (id) {
            obj.id = id
            props.onChange([{...editorData, ...products, ...obj}])
        }
        setEditorData({...obj})


        if(edit && tempItem[item])
            tempItem[item].content = obj.content
    }

    const sort = (array) => {
        return array.sort((a, b) => {
            return a.id - b.id
        })
    }

    const handleTempItems = () => {
        let obj = {...editorData, ...products}
        let dataForSend = [...tempItem, obj]
        if(Object.keys(dataForSend?.at(-1)).length === 0 ) {
            toast.error("ثبت نشد . دوباره تلاش کنید")
        } else {
            toast.success("با موفقیت ثبت شد")
            setTempItem(dataForSend)
            props.onChange(dataForSend)
        }
    }

    const handleStep = (step) => {
        setEdit(null)
        if (title !== "" || form.products?.length > 0 || editorData?.details?.body.length > 0) {
            setAlarmModal(true)
        } else {
            setSection(step)
        }
    }

    const handleChangeDataStep = (permission) => {
        if (permission) {
            setSection(section === 1 ? 2 : 1)
            setProducts({})
            setEditorData({})
            setForm(initStat)
            setAlarmModal(false)
            setTitle("")
        } else {
            setAlarmModal(false)
        }
    }
    return (
        <>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="server-modal-title"
                aria-describedby="server-modal-description"
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 2,
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: '90%', sm: '80%', md: '70%' },
                            height: { xs: 300, sm: 400, md: 500 },
                            backgroundColor: 'white',
                            borderRadius: 1,
                            overflow: 'hidden',
                        }}
                    >
                        <iframe
                            src={address}
                            title="Embedded Content"
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    </Box>
                </Box>
            </Modal>
            <form>

                <>
                    <div>
                        {
                            tempItem?.map((item , index) => {
                                return(
                                    <>
                                        {
                                            item?.content ?
                                                <Paper
                                                    sx={{
                                                        p: "20px",
                                                        mb: "25px",
                                                        boxShadow: "none",
                                                        position: "relative",
                                                        flexDirection: "column",
                                                        textAlign: "center",
                                                        borderRadius: "5px",
                                                        color: "text.secondary",
                                                        backgroundColor: "white",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <IconButton onClick={() => setEdit(edit !== null ? null : index)}
                                                                className='edit-btn animated flash'>
                                                        <EditIcon/>
                                                    </IconButton>
                                                    <IconButton onClick={() => handleDelete(item.id , index)} color={"default"}
                                                                className='remove-btn animated flash'>
                                                        <HighlightOffIcon/>
                                                    </IconButton>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            {
                                                                edit === index ?
                                                                    <>
                                                                        <Grid xs={12} item>
                                                                            <TextField
                                                                                id="outlined-name"
                                                                                type={"search"}
                                                                                label={"عنوان"}
                                                                                variant="outlined"
                                                                                margin='dense'
                                                                                fullWidth
                                                                                name='title'
                                                                                InputLabelProps={{
                                                                                    shrink: true,
                                                                                }}
                                                                                title={"عنوان"}
                                                                                onChange={(e) => handleTitleEditor(e.target.value , item.id)}
                                                                                value={title || item.title}
                                                                            />
                                                                        </Grid>
                                                                        <SunEditor
                                                                            setOptions={{
                                                                                height: 200,
                                                                                buttonList: buttonList.complex
                                                                            }}
                                                                            value={editorData}
                                                                            height="600px"
                                                                            getSunEditorInstance={getSunEditorInstance}
                                                                            defaultValue={item?.content}
                                                                            onChange={(e) => handleEditor(e, item.item_id , true , form.title || item.title)}
                                                                        />
                                                                    </>
                                                                    :
                                                                    <div
                                                                        dangerouslySetInnerHTML={{__html: item?.content}}/>

                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Paper>
                                                :
                                                <Paper
                                                    sx={{
                                                        p: "20px",
                                                        mb: "25px",
                                                        boxShadow: "none",
                                                        position: "relative",
                                                        flexDirection: "column",
                                                        textAlign: "center",
                                                        borderRadius: "5px",
                                                        color: "text.secondary",
                                                        backgroundColor: "white",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <IconButton onClick={() => setEdit(edit !== null ? null : index)}
                                                                className='edit-btn animated flash'>
                                                        <EditIcon/>
                                                    </IconButton>
                                                    <IconButton onClick={() => handleDelete(item.id)} color={"default"}
                                                                className='remove-btn animated flash'>
                                                        <HighlightOffIcon/>
                                                    </IconButton>
                                                    <Grid container spacing={2}>
                                                        {
                                                            edit === index ?
                                                                <>
                                                                    <Grid xs={12} item>
                                                                        <Grid xs={12} item>
                                                                            <TextField
                                                                                id="outlined-name"
                                                                                type={"search"}
                                                                                label={"عنوان"}
                                                                                variant="outlined"
                                                                                margin='dense'
                                                                                fullWidth
                                                                                name='title'
                                                                                InputLabelProps={{
                                                                                    shrink: true,
                                                                                }}
                                                                                title={"عنوان"}

                                                                                onChange={(e) => handleTitle(e.target.value , item.id)}
                                                                                value={title || item.title}
                                                                            />
                                                                        </Grid>
                                                                        <SelectProduct title={"لیست محصولات"}
                                                                                       list={productReducer}
                                                                                       state={"products"}
                                                                                       formData={item}
                                                                                       onchange={(e) => handleProduct(e , item.id , true , form.title || item.title)}/>
                                                                    </Grid>
                                                                </>
                                                                :
                                                                <Grid  xs={12}>
                                                                    {
                                                                        item?.products?.map((item) => {
                                                                            return(
                                                                                (item?.title ?? item) + " / "
                                                                          )
                                                                        })
                                                                    }
                                                                </Grid>
                                                        }
                                                    </Grid>
                                                </Paper>

                                        }
                                    </>
                                )
                            })

                        }


                        <Grid container spacing={2}>
                            <Grid item>
                                <Button onClick={() => {
                                    handleStep(1)
                                }} disabled={loading} variant='contained'
                                        color='primary'>ایجاد محصولات</Button>
                            </Grid>
                            <Grid item>
                                <Button onClick={() => {
                                    handleStep(2)
                                }} disabled={loading} variant='contained'
                                        color='primary'>ایجاد متن</Button>
                            </Grid>

                            <Grid item>
                                <Button onClick={() => {
                                    setOpenModal(true)
                                }} disabled={loading} variant='contained'
                                        color='primary'>مشاهده دموی صفحه</Button>
                            </Grid>

                            <Grid item>
                                <Button onClick={() => {
                                    navigator.clipboard.writeText(address)
                                    setCopy(true)
                                }} disabled={loading} variant='contained'
                                        color='primary'>{!copy ? "کپی آدرس" : "کپی شد"}</Button>
                            </Grid>
                            <Grid item>
                                <Button onClick={() => {
                                    handleTempItems()
                                }}
                                        disabled={loading || (form.products?.length === 0 && editorData?.details?.body.length === 0) || edit !== null}
                                        variant='contained'
                                        color='secondary'>ثبت موقت</Button>
                            </Grid>

                        </Grid>

                        <Grid container spacing={2}>
                            {
                                section === 1 &&
                                <>
                                    <Grid xs={12} item>
                                        <TextField
                                            id="outlined-name"
                                            type={"search"}
                                            label={"عنوان"}
                                            variant="outlined"
                                            margin='dense'
                                            fullWidth
                                            name='title'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            title={"عنوان"}
                                            onChange={(e) => {
                                                form.title = e.target.value
                                                setTitle(e.target.value)
                                            }}
                                            value={title}
                                        />
                                    </Grid>
                                    <Grid xs={12} item>
                                        <SelectProduct title={"لیست محصولات"} list={productReducer} state={"products"}
                                                       formData={form}
                                                       onchange={(e) => handleProduct(e)}/>
                                    </Grid>
                                </>
                            }

                            {
                                section === 2 &&
                                <>
                                    <Grid xs={12} item>
                                        <TextField
                                            id="outlined-name"
                                            type={"search"}
                                            label={"عنوان"}
                                            variant="outlined"
                                            margin='dense'
                                            fullWidth
                                            name='title'
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            title={"عنوان"}
                                            onChange={(e) => {
                                                form.title = e.target.value
                                                setTitle(e.target.value)
                                            }}
                                            value={form.title}
                                        />
                                    </Grid>
                                    <Grid xs={12} item>
                                        <SunEditor
                                            setOptions={{
                                                height: 200,
                                                buttonList: buttonList.complex
                                            }}
                                            value={editorData}
                                            height="600px"
                                            getSunEditorInstance={getSunEditorInstance}
                                            defaultValue={editorData}
                                            onChange={(e) => handleEditor(e, null , true , form.title)}
                                        />
                                    </Grid>
                                </>

                            }
                        </Grid>
                        <Modal
                            disablePortal
                            disableEnforceFocus
                            disableAutoFocus
                            open={alarmModal}
                            onClose={() => {
                                setAlarmModal(false)
                            }}
                            aria-labelledby="server-modal-title"
                            aria-describedby="server-modal-description"
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    p: 2,
                                    height: "100vh",
                                    backgroundColor: "rgba(0, 0, 0, 0.3)"
                                }}
                            >
                                <Paper
                                    sx={{
                                        p: 3,
                                        width: { xs: "90%", sm: "60%", md: "40%" }, // استفاده از sm برای تنظیم عرض روی سایزهای مختلف دستگاه
                                        textAlign: "center"
                                    }}
                                >
                                    <h4 id="modal-title">شما تغییرات ذخیره نشده دارید</h4>
                                    <ButtonGroup
                                        variant="outlined"
                                        color="primary"
                                        aria-label="outlined primary button group"
                                        sx={{ mt: 2 }}
                                    >
                                        <Button  onClick={() => {
                                            handleChangeDataStep(true)
                                        }} >ادامه</Button>
                                        <Button  onClick={() => {
                                            handleChangeDataStep(false)
                                        }}
                                        >ماندن</Button>
                                    </ButtonGroup>
                                </Paper>
                            </Box>
                        </Modal>
                    </div>
                </>
            </form>
        </>
    );
})


const mapStateToProps = state => ({
    authReducer: state.authReducer,
    productReducer: state.productReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchProducts: (object) => {
        dispatch(productAction.fetchProducts(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPageCreate)



